var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('cdn-background-image', {
    staticClass: "flex-grow-0",
    attrs: {
      "src": _vm.src,
      "alt": _vm.alt,
      "size": _vm.size,
      "gradient": _vm.gradient,
      "blur": _vm.blur,
      "cover": ""
    }
  }, [_vm.$slots.default ? _c('div', {
    staticClass: "absolute w-full h-full left-0 top-0"
  }, [_vm._t("default")], 2) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }